export * from "./interfaces/values";
export {
    SuiLocalizationModule,
    SuiLocalizationService
} from "./index";
